import React from 'react';
import { Modal, Icon } from 'antd';

import './index.less';

class ExpireModal extends React.Component {
  render() {
    //const { expired } = this.props;
    const content = "<div>尊敬的蛋仔商家中心软件产品用户：<br><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您的产品已超期未续费。您可以通过以下联系方式续费使用该产品。</p><p>如需续费，请联系：</p><p>微信号：mingdao<br>联系电话：18801627709<br>公司座机：021-61551111</p><div style='text-align:right'>蛋仔商家中心软件产品团队</div></div>";
    return (
      <Modal
        visible={true}
        title=""
        keyboard={false}
        maskClosable={false}
        closable={false}
        footer={null}
      >
        <div style={{fontSize:'16px',fontWeight:'500',color: 'rgba(0,0,0,.85)'}}><Icon type="exclamation-circle" style={{color: '#faad14',fontSize:'22px',marginRight: '16px'}}/><span>通知</span></div>
        <div style={{marginLeft: '32px',marginTop: '8px'}} dangerouslySetInnerHTML={{__html: content}}></div>
      </Modal>
    )
  }
}

export default ExpireModal;



// WEBPACK FOOTER //
// ./src/components/ExpireModal/index.jsx